import { render, staticRenderFns } from "./StockOrdersActions.vue?vue&type=template&id=07291067"
import script from "./StockOrdersActions.vue?vue&type=script&lang=js"
export * from "./StockOrdersActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports